module.exports = __webpack_public_path__ + "static/media/facebook_icon.2151a4a8.svg";